import React from "react";
import { TextComponent } from "../../../../components";
import styles from "./personalization.module.css";
import { Col, Row } from "antd";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { VscCircleLarge } from "react-icons/vsc";
import { useDispatch, useSelector } from "react-redux";
import { changeThemeColor, changeThemeFont } from "../../../../Store/Actions/AuthAction";

function Personalization() {
  const dispatch = useDispatch();
  const themecolor = useSelector((state) => state.AuthReducer.themeColor);
  const fontFamily = useSelector((state) => state.AuthReducer.fontFamily);

  const changeTheme = (color) => {
    dispatch(changeThemeColor(color));
  };
  const changefonts = (font) => {
    dispatch(changeThemeFont(font));
  };
  console.log("render");
  const colors = [
    { color: "#8E65A1", isActive: false },
    { color: "#ED73AA", isActive: true },
    { color: "#562ED6", isActive: false },
    { color: "#4B246B", isActive: false },
    { color: "#000000", isActive: false },
  ];
  const fonts = [
    { font: "Poppins", fontFamily: "'Poppins', sans-serif" },
    { font: "Sacramento", fontFamily: "'Sacramento', cursive" },
    { font: "Baskerville Old Face", fontFamily: "Baskerville Old Face" },
    { font: "Lexend", fontFamily: "'Lexend', sans-serif" },
    { font: "Californian FB", fontFamily: "Californian" },
  ];
  return (
    <div>
      <TextComponent text="Personalization" textClass={styles.textHeading} />
      <Row>
        <TextComponent text="Change Colour" textClass={styles.text} />
      </Row>
      <Row>
        {colors.map((data) => (
          <div
            className={`${styles.colorOutlineCont} ${
              data.color == themecolor ? styles.borderClass : ""
            }`}
            style={{
              borderColor: data.color,
            }}
            onClick={() => changeTheme(data.color)}
          >
            <Col
              className={styles.colorCont}
              style={{ backgroundColor: data.color }}
            ></Col>
          </div>
        ))}
      </Row>
      <Row>
        <TextComponent text="Change Font" textClass={styles.text} />
      </Row>
      {fonts.map((data) => (
        <Row
          className={styles.fontsCont}
          onClick={() => changefonts(data.fontFamily)}
        >
          <Col>
            <TextComponent
              text={data.font}
              style={{ fontFamily: data.fontFamily }}
            />
          </Col>
          <Col>
            {fontFamily == data.fontFamily ? (
              <BsFillCheckCircleFill size={30} className={styles.fontIcon} />
            ) : (
              <VscCircleLarge size={30} className={styles.fontIcon} />
            )}
          </Col>
        </Row>
      ))}
    </div>
  );
}

export default Personalization;
